<template>
  <div :class="style.buttonBlock" v-if="mobileVersion" ref="buttonBlock">
    <div :class="style.button" v-text="'Далее'" />
    <textarea
      v-model="textBellowButton"
      :style="{width: textBellowButton?.length * 7 + 'px!important'}"
      placeholder="Текст под кнопкой"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ButtonBlockComponent.module.scss";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

export default defineComponent({
  name: "ButtonBlockComponent",
  data() {
    return {
      style
    };
  },

  computed: {
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    },
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    quiz() {
      return this.$quizStore.getQuiz;
    },
    textBellowButton(): string {
      return modifyQuiz("get", "", ["textBellowButton"]) ?? "";
    }
  },
  watch: {
    textBellowButton(newVal) {
      modifyQuiz("set", newVal, ["textBellowButton"]);
    }
  }
});
</script>
